import { createStore, withProps } from "@ngneat/elf";
import { withEntities } from "@ngneat/elf-entities";
import { withRequestsStatus } from "@ngneat/elf-requests";

import {
  TransactionFilter,
  TransactionLight,
  TransactionFull,
  TransactionTotal,
  ExportTransaction,
  TransactionPeriod,
} from "./transaction.models";

interface TransactionStoreProps {
  filters: TransactionFilter;
  transaction?: TransactionFull;
  totals?: TransactionTotal;
  exportTransaction?: ExportTransaction;
  loading: boolean;
  hasMore: boolean;
  selectedPeriod?: TransactionPeriod;
}

export const MONTH_TO_LOAD = 5;
export const transactionStore = createStore(
  { name: "transaction" },
  withProps<TransactionStoreProps>({
    filters: {},
    exportTransaction: {} as ExportTransaction,
    loading: false,
    hasMore: true,
  }),
  withEntities<TransactionLight>(),
  withRequestsStatus()
);

export const transactionPeriodStore = createStore(
  { name: "transactionPeriod" },
  withEntities<TransactionPeriod>(),
  withRequestsStatus()
);
